import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class SpringCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Spring Cleaning Gold Coast | Seasonal Deep Home Clean"
          description="Spring cleaning Gold Coast professionals. Complete seasonal deep cleaning for homes, apartments and rental properties."
          keywords="spring cleaning gold coast, seasonal cleaning gold coast, deep home cleaning gold coast, house refresh cleaning gold coast, annual deep cleaning gold coast, apartment spring cleaning gold coast, unit deep cleaning gold coast, thorough house cleaning gold coast, dust removal cleaning gold coast, window washing gold coast, bathroom descaling gold coast, tile and grout cleaning gold coast, floor scrubbing gold coast, full house sanitisation gold coast, pre event cleaning gold coast, post renovation cleaning gold coast, professional spring cleaners gold coast, eco friendly spring cleaning gold coast, affordable spring cleaning gold coast, one off house cleaning gold coast, heavy duty cleaning gold coast, kitchen deep cleaning gold coast, bedroom deep cleaning gold coast, living room cleaning gold coast, house makeover cleaning gold coast, trusted seasonal cleaners gold coast, detailed property cleaning gold coast, home hygiene cleaning gold coast, residential deep sanitisation gold coast, complete home cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Spring Cleaning Gold Coast</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Spring Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Over time, homes accumulate dust, grime and clutter
                            that routine cleaning may not fully remove. Our
                            spring cleaning Gold Coast service is designed to
                            provide a complete and thorough refresh of your
                            home. Whether you are preparing for a new season,
                            hosting guests or simply want a fresh start, our
                            professional cleaners deliver exceptional results.
                          </p>
                          <p>
                            Spring cleaning is more than basic tidying. It
                            involves deep cleaning areas that are often
                            overlooked during regular maintenance. Kangaroo
                            Shine Property Services ensures every corner of your
                            home is cleaned and sanitised.
                          </p>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            What Is Included in Spring Cleaning
                          </h4>
                          <p>
                            Our spring cleaning Gold Coast service includes:
                          </p>

                          <h5 className="m-b10">Kitchen Deep Cleaning</h5>
                          <ul className="list-check primary">
                            <li>Cleaning inside cupboards and drawers</li>
                            <li>Degreasing stovetops and range hoods</li>
                            <li>Oven cleaning</li>
                            <li>Cleaning splashbacks and tiles</li>
                            <li>Floor scrubbing</li>
                          </ul>

                          <h5 className="m-b10 m-t20">
                            Bathroom Deep Cleaning
                          </h5>
                          <ul className="list-check primary">
                            <li>Removing soap scum</li>
                            <li>Descaling shower screens</li>
                            <li>Tile and grout cleaning</li>
                            <li>Sanitising toilets and basins</li>
                            <li>Cleaning mirrors and cabinets</li>
                          </ul>

                          <h5 className="m-b10 m-t20">Living Areas</h5>
                          <ul className="list-check primary">
                            <li>Dusting furniture and surfaces</li>
                            <li>Cleaning skirting boards</li>
                            <li>Vacuuming carpets</li>
                            <li>Mopping hard floors</li>
                            <li>Cleaning light fixtures</li>
                          </ul>

                          <h5 className="m-b10 m-t20">Bedrooms</h5>
                          <ul className="list-check primary">
                            <li>Dusting wardrobes</li>
                            <li>Vacuuming under beds</li>
                            <li>Cleaning windows</li>
                            <li>Removing cobwebs</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Benefits of Professional Spring Cleaning
                          </h4>
                          <ul className="list-check primary">
                            <li>Improved air quality</li>
                            <li>Reduced allergens</li>
                            <li>Enhanced home presentation</li>
                            <li>Healthier living environment</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Kangaroo Shine for Spring Cleaning
                          </h4>
                          <ul className="list-check primary">
                            <li>Experienced professional cleaners</li>
                            <li>Systematic deep cleaning approach</li>
                            <li>Flexible scheduling</li>
                            <li>Eco friendly products</li>
                            <li>Reliable service</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Service Areas</h4>
                          <ul className="list-check primary">
                            <li>Gold Coast</li>
                            <li>Surfers Paradise</li>
                            <li>Broadbeach</li>
                            <li>Burleigh Heads</li>
                            <li>Southport</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Book Spring Cleaning Today
                          </h4>
                          <p>
                            Contact Kangaroo Shine Property Services for
                            professional spring cleaning Gold Coast.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default SpringCleaningGoldCoast;
